import { COMPARE_SLUGS } from './slugs';
import type { ICompetitor } from './types';

const loadCompareEn = (): Promise<Record<string, ICompetitor>> =>
  import('./en').then((m) => m.compareContentEn);

const compareContentLoaders: Record<string, () => Promise<Record<string, ICompetitor>>> = {
  ar: () => import('./ar').then((m) => m.compareContentAr),
  bn: () => import('./bn').then((m) => m.compareContentBn),
  de: () => import('./de').then((m) => m.compareContentDe),
  en: loadCompareEn,
  es: () => import('./es').then((m) => m.compareContentEs),
  fa: () => import('./fa').then((m) => m.compareContentFa),
  fr: () => import('./fr').then((m) => m.compareContentFr),
  hi: () => import('./hi').then((m) => m.compareContentHi),
  it: () => import('./it').then((m) => m.compareContentIt),
  pt: () => import('./pt').then((m) => m.compareContentPt),
  ru: () => import('./ru').then((m) => m.compareContentRu),
  ur: () => import('./ur').then((m) => m.compareContentUr),
  zh: () => import('./zh').then((m) => m.compareContentZh),
};

export function getCompareContent(locale: string): Promise<Record<string, ICompetitor>> {
  return (compareContentLoaders[locale] ?? loadCompareEn)();
}

export const competitorSlugs: readonly string[] = COMPARE_SLUGS;

export type {
  ICompareCategory,
  ICompareDifferentiator,
  ICompareMidCta,
  ICompareRow,
  ICompareSection,
  ICompareVerdict,
  ICompetitor,
} from './types';
